import React from "react";
import { Outlet } from "react-router-dom";


const PublicLayout = () => {

  return (
    <div>
      <main className="">
        <div className="">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default PublicLayout;
